<div class="grid-container margin-top">
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="activeBonds" (firstDataRendered)="resizeColumns($event)" aria-label="Certificate Of Deposit Report"></ag-grid-angular>
</div>
